import React, {useEffect, useState, useRef, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import "./style.scss";

import TabsMenu from "../../../components/TabsMenu";
import Loader from "../../../components/Loader";
import "../../../components/Loader/style.scss";
import {
  checkContentAvlInArray,
  // dataDashboard,
  createDropdownCompatibleData,
  createDropdownCompatibleStoreData,
} from "../../../util";
import BlockBtn from "../../../components/BlockBtn";

import {API, processApiResponse} from "../../../services/HttpHandler";

import {getRegions, getStores} from "../../../services/Filters";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../../services/SessionStorage";
import {ADOBEDTM_PAGE_NAME} from "../../../constants";
import SlotBookingError from "../../SlotBooked/SlotBookingError";
import {StepperWrapper} from "../../../components/StepperWrapper";
import Dropdown from "../../../components/Dropdown/Dropdown";

import config from "../../../../config";

const StoreSelect = () => {
  const [availableStores, setAvailableStores] = useState([]);
  const [region, setRegion] = useState(null);
  const [bu, setBu] = useState();
  const [loading, setLoading] = useState(false);
  const [allRegions, setAllRegions] = useState([]);
  const allStores = useRef([]);
  const [selectedStore, setSelectedStore] = useState({});
  const [error, setError] = useState("");
  const navigate = useRef(useNavigate());
  const {t} = useTranslation();
  const updatedCustomerSlotDetails = useRef(getCustomerSlotDetails());
  const [buList, setBuList] = useState([]);
  const isStoreDropdownEnable = !!region && !!bu;
  const fetchBUList = useCallback(async (buName, countryCode, isOffice) => {
    let currentBU = buName;

    try {
      setLoading(true);
      const prepareURL = isOffice
        ? `?office=${isOffice}`
        : `?country=${countryCode}`;
      let response = await API.get(config.endPoints.availableBUs + prepareURL);
      response = await processApiResponse(response);
      let completedata = [];
      let latestBU = "";
      const performCheck = config.stand_alone_bu_list.includes(currentBU)
        ? false
        : true;
      if (
        performCheck &&
        checkContentAvlInArray(config.shared_bu_user_detail, [currentBU])
      ) {
        completedata = [currentBU];
      } else if (performCheck) {
        let configSharedBUList = config.shared_platform_bu_list;
        let tempResponseArray = response;
        configSharedBUList = configSharedBUList.filter(function (item) {
          return tempResponseArray.includes(item);
        });
        completedata = configSharedBUList;
      } else {
        completedata = [currentBU];
      }
      latestBU = completedata.includes(currentBU) ? currentBU : completedata[0];
      const tmpData = createDropdownCompatibleData(completedata);
      setBuList(tmpData);
      setBu({value: latestBU, label: latestBU});
      let sessionData = getCustomerSlotDetails();
      let tempData = {...sessionData};
      tempData["buList"] = completedata;
      tempData["bu"] = latestBU;
      setCustomerSlotDetails({
        ...updatedCustomerSlotDetails.current,
        ...tempData,
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStores = useCallback(
    async (bu) => {
      const {country, source, isOffice} = updatedCustomerSlotDetails.current;

      try {
        setLoading(true);
        setError("");
        const requestedBU = bu.value;
        const prepareURL = isOffice
          ? `&office=${isOffice}`
          : `&country=${country}`;
        let response = await API.get(
          config.endPoints.stores +
            `?businessunit=${requestedBU}&source=${source}` +
            prepareURL
        );
        response = await processApiResponse(response);
        allStores.current = response;
        const regions = getRegions(allStores.current);
        const preferrredLoc = config.preferredLocation[requestedBU];
        let prefLoc = preferrredLoc
          ? preferrredLoc[updatedCustomerSlotDetails.current.country]
          : undefined;
        if (isOffice) {
          //STSWA- 567-Location is added only for teams.
          prefLoc = "Santiago";
        }
        const isPrefRegionPresent = prefLoc
          ? regions.filter((e) => {
              return e === prefLoc;
            })
          : undefined;

        prefLoc = isPrefRegionPresent
          ? isPrefRegionPresent.length === 1
            ? prefLoc
            : regions[0]
          : regions[0];
        const tmpData = createDropdownCompatibleData(regions);
        setAllRegions(tmpData);
        setRegion({value: prefLoc, label: prefLoc});
        setAvailableStores(
          createDropdownCompatibleStoreData(
            getStores(allStores.current, prefLoc)
          )
        );
        return true;
      } catch (error) {
        setError(t("error.failedToFetchStores"));
        return false;
      } finally {
        setLoading(false);
      }
    },
    [t]
  );

  useEffect(() => {
    async function checkValidBU() {
      fetchBUList(
        updatedCustomerSlotDetails.current.bu,
        updatedCustomerSlotDetails.current.country,
        updatedCustomerSlotDetails.current.isOffice
      );
    }
    checkValidBU();
  }, [fetchBUList]);

  useEffect(() => {
    if (bu) fetchStores(bu);
  }, [bu, fetchStores]);

  useEffect(() => {
    if (availableStores.length) {
      if (availableStores[0]?.stdCode) {
        availableStores[0].callCode = "+" + availableStores[0]?.stdCode + " ";
      }
      setSelectedStore({});
    }
  }, [availableStores]);

  useEffect(() => {
    if (region) {
      const regionName = region.value ? region.value : region;
      setAvailableStores(
        createDropdownCompatibleStoreData(
          getStores(allStores.current, regionName)
        )
      );
    }
  }, [region]);

  // useEffect(() => {
  //   let timer = setTimeout(() => {
  //     // for data dashboard
  //     const URL = window.location.href.split("/")[2];
  //     const officeApp = updatedCustomerSlotDetails.current.isOffice
  //       ? URL + "/office"
  //       : URL + "/app";
  //     const datamap = new Map();
  //     datamap.set("pageName", ADOBEDTM_PAGE_NAME.CT_Store_Selection);
  //     datamap.set("prop1", URL);
  //     datamap.set("prop2", officeApp);
  //     dataDashboard(datamap);
  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   }, 1000);
  // }, []);

  const makeBooking = () => {
    updatedCustomerSlotDetails.current.currentBookingDetails = {selectedStore};
    updatedCustomerSlotDetails.current.currentBookingDetails.bu = bu;
    updatedCustomerSlotDetails.current.currentBookingDetails.region = region;
    if (selectedStore.mallId) {
      let selectedMallStores = {};
      selectedMallStores.uuid = selectedStore.mallId;
      updatedCustomerSlotDetails.current.selectedMallStores = [
        selectedMallStores,
      ];
    } else {
      updatedCustomerSlotDetails.current.selectedMallStores = [];
    }
    setCustomerSlotDetails(updatedCustomerSlotDetails.current);
    // const datamap = new Map();
    // datamap.set("events", "event16=1");
    // datamap.set("eVar8", bu);
    // datamap.set("eVar5", selectedStore.storeName);
    // datamap.set("eVar9", region);
    // dataDashboard(datamap);
    navigate.current("/customer/bookslot");
  };

  const handleClick = () => {
    makeBooking();
  };

  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <>
      <TabsMenu path="SelectStore" />
      {!error ? (
        <>
          <div className="main-container">
            <StepperWrapper current={0} />
            <label className="heading">{t("selectStore.heading")}</label>
            <label className="office-select-label-text sub-heading">
              {t("selectStore.subheading")}
            </label>
            <div className="office-content-wrapper">
              <div className="office-wrap">
                <label className="office-select-label-text">{t("bu")}</label>
                <Dropdown
                  options={buList}
                  onChange={(data) => setBu(data.option)}
                  value={bu ? bu : null}
                  size="md"
                  disabled={buList && buList.length === 1 ? true : false}
                />
              </div>
              <div className="office-wrap">
                <label className="office-select-label-text">
                  {t("region")}
                </label>
                <Dropdown
                  options={allRegions}
                  onChange={(data) => setRegion(data.option)}
                  value={region ? region : null}
                  size="md"
                  disabled={
                    allRegions && allRegions.length === 1 ? true : false
                  }
                />
              </div>
              {isStoreDropdownEnable && (
                <div className="office-wrap">
                  <label className="office-select-label-text">
                    {t("store.label")}
                  </label>
                  <Dropdown
                    options={availableStores}
                    onChange={(data) => setSelectedStore(data.option)}
                    value={selectedStore ? selectedStore : null}
                    placeholder="Selecciona..."
                    size="md"
                  />
                </div>
              )}
            </div>
            <div className="footer-div">
              <BlockBtn
                name={t("proceed.label")}
                handleClick={handleClick}
                disabled={
                  selectedStore && Object.keys(selectedStore).length === 0
                }
              />
            </div>
          </div>
        </>
      ) : (
        <SlotBookingError error={error} />
      )}
    </>
  );
};

export default StoreSelect;
